'use strict';

export default {
  soParams: {},//keyword, dig, digKeyword
  soCompanyInfo: {},//公司信息
  soEmailList: {},//邮件信息
  soHistory: {},//搜索框历史
  soHistoryList: {},//历史记录,
  submitCid:false,
  crmInfo:{},
  soLoaded:true,//记录搜索记录是否到达
  soSearchType:1,
  searchEmailInCompany:false,
  scrollItems:[], //页面变化记录
};



// WEBPACK FOOTER //
// ./src/store/modules/so/state.js